// 组件共享的样式常量
export type ComponentSize = 'small' | 'middle' | 'large';

export const sizeClasses: Record<ComponentSize, string> = {
  small: 'px-3 py-1.5 text-xs',
  middle: 'px-4 py-2 text-sm',
  large: 'px-6 py-3 text-base',
};

export const inputSizeClasses: Record<ComponentSize, string> = {
  small: 'px-3 py-1.5 text-xs',
  middle: 'px-4 py-2 text-sm',
  large: 'px-6 py-3 text-base',
};
